import { AsyncAxiosRequestConfig } from 'core/common';
import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from 'config';
import { PhoneCompany } from './phone-company.model';
import { PhoneType, PhoneTypes } from './phone-type.model';
import { BillingPhoneResponse } from './billing-phone.model';

interface PhoneCompaniesResponse {
  phoneCompanies: PhoneCompany[];
}

interface PhoneCodeValidationResponse {
  nameCode: string;
  validCode: boolean;
  errorCode: number;
}

class PhoneAPI {
  async getCompanies() {
    const { data } = await axiosInstance.get<PhoneCompaniesResponse>(
      '/servicios_fijos/v1/phone_companies'
    );
    return data?.phoneCompanies || [];
  }

  async validatePhoneCode(
    codePhone: string | number,
    options?: AxiosRequestConfig
  ) {
    const { data } = await axiosInstance.get<PhoneCodeValidationResponse>(
      `/servicios_fijos/v1/clients/phone_codes/${codePhone}`,
      options
    );
    return data.validCode;
  }

  async getCompanyFromNumber(
    options: AsyncAxiosRequestConfig<{ phone_line: string }>
  ) {
    const { data } = await axiosInstance.get<{
      number: string;
      status: string;
    }>(`servicios_fijos/v1/phones/${options.params.phone_line}`);

    return data;
  }

  getTypes(): PhoneType[] {
    return [
      { value: PhoneTypes.Fijo, label: PhoneTypes.Fijo },
      { value: PhoneTypes.Celular, label: PhoneTypes.Celular },
    ];
  }

  getDefaultPhoneType(): string {
    return PhoneTypes.Celular;
  }

  async validateBillingPhone(
    options: AsyncAxiosRequestConfig<{ phoneNumber?: string }>
  ) {
    const { data } = await axiosInstance.get<BillingPhoneResponse>(
      `/servicios_fijos/v1/billing_phone/${options.params.phoneNumber}`
    );
    return data;
  }
}

export default new PhoneAPI();
